import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _407fc104 = () => interopDefault(import('../client/pages/accessibility.vue' /* webpackChunkName: "pages/accessibility" */))
const _d5274abc = () => interopDefault(import('../client/pages/ask-the-nutritionist.vue' /* webpackChunkName: "pages/ask-the-nutritionist" */))
const _5613b56e = () => interopDefault(import('../client/pages/checkout/index.vue' /* webpackChunkName: "pages/checkout/index" */))
const _1ef59b50 = () => interopDefault(import('../client/pages/contact.vue' /* webpackChunkName: "pages/contact" */))
const _130416b5 = () => interopDefault(import('../client/pages/forgot-password.vue' /* webpackChunkName: "pages/forgot-password" */))
const _66dc0503 = () => interopDefault(import('../client/pages/free_trial.vue' /* webpackChunkName: "pages/free_trial" */))
const _75fa2fc8 = () => interopDefault(import('../client/pages/get_started.vue' /* webpackChunkName: "pages/get_started" */))
const _d084438e = () => interopDefault(import('../client/pages/giveaway-terms.vue' /* webpackChunkName: "pages/giveaway-terms" */))
const _3bf49fe2 = () => interopDefault(import('../client/pages/instagram.vue' /* webpackChunkName: "pages/instagram" */))
const _4229a656 = () => interopDefault(import('../client/pages/jobs.vue' /* webpackChunkName: "pages/jobs" */))
const _2667e019 = () => interopDefault(import('../client/pages/login.vue' /* webpackChunkName: "pages/login" */))
const _063948ad = () => interopDefault(import('../client/pages/loyalty-program.vue' /* webpackChunkName: "pages/loyalty-program" */))
const _3cf1979d = () => interopDefault(import('../client/pages/my_account/index.vue' /* webpackChunkName: "pages/my_account/index" */))
const _2121d571 = () => interopDefault(import('../client/pages/nutritionists.vue' /* webpackChunkName: "pages/nutritionists" */))
const _3451cb38 = () => interopDefault(import('../client/pages/our-story.vue' /* webpackChunkName: "pages/our-story" */))
const _860ec778 = () => interopDefault(import('../client/pages/personalize.vue' /* webpackChunkName: "pages/personalize" */))
const _45df5f87 = () => interopDefault(import('../client/pages/plan-and-save.vue' /* webpackChunkName: "pages/plan-and-save" */))
const _56a797f3 = () => interopDefault(import('../client/pages/press.vue' /* webpackChunkName: "pages/press" */))
const _7621a6b8 = () => interopDefault(import('../client/pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _5b3c928f = () => interopDefault(import('../client/pages/product-philosophy.vue' /* webpackChunkName: "pages/product-philosophy" */))
const _98921f38 = () => interopDefault(import('../client/pages/products.vue' /* webpackChunkName: "pages/products" */))
const _2171f0c7 = () => interopDefault(import('../client/pages/products/category/_category.vue' /* webpackChunkName: "pages/products/category/_category" */))
const _09dfaa0a = () => interopDefault(import('../client/pages/recommendations.vue' /* webpackChunkName: "pages/recommendations" */))
const _968da892 = () => interopDefault(import('../client/pages/refer-a-friend.vue' /* webpackChunkName: "pages/refer-a-friend" */))
const _60db57d9 = () => interopDefault(import('../client/pages/reset-password.vue' /* webpackChunkName: "pages/reset-password" */))
const _a5b560d8 = () => interopDefault(import('../client/pages/science.vue' /* webpackChunkName: "pages/science" */))
const _e3cc5d36 = () => interopDefault(import('../client/pages/sitemap.vue' /* webpackChunkName: "pages/sitemap" */))
const _5695e5b2 = () => interopDefault(import('../client/pages/sustainability.vue' /* webpackChunkName: "pages/sustainability" */))
const _33ecec74 = () => interopDefault(import('../client/pages/terms-and-conditions.vue' /* webpackChunkName: "pages/terms-and-conditions" */))
const _afd48f74 = () => interopDefault(import('../client/pages/wholesale-inquiries.vue' /* webpackChunkName: "pages/wholesale-inquiries" */))
const _4030f08e = () => interopDefault(import('../client/pages/checkout/confirmation.vue' /* webpackChunkName: "pages/checkout/confirmation" */))
const _1bcebefc = () => interopDefault(import('../client/pages/my_account/cancel/index.vue' /* webpackChunkName: "pages/my_account/cancel/index" */))
const _3b3bad63 = () => interopDefault(import('../client/pages/my_account/customer.vue' /* webpackChunkName: "pages/my_account/customer" */))
const _09779bca = () => interopDefault(import('../client/pages/my_account/membership.vue' /* webpackChunkName: "pages/my_account/membership" */))
const _2a19ec0e = () => interopDefault(import('../client/pages/my_account/nutrition-report.vue' /* webpackChunkName: "pages/my_account/nutrition-report" */))
const _32c951e3 = () => interopDefault(import('../client/pages/my_account/order-history/index.vue' /* webpackChunkName: "pages/my_account/order-history/index" */))
const _38a405cf = () => interopDefault(import('../client/pages/my_account/routine.vue' /* webpackChunkName: "pages/my_account/routine" */))
const _6afdd996 = () => interopDefault(import('../client/pages/my_account/cancel/confirmation.vue' /* webpackChunkName: "pages/my_account/cancel/confirmation" */))
const _51f59cdd = () => interopDefault(import('../client/pages/my_account/cancel/survey/index.vue' /* webpackChunkName: "pages/my_account/cancel/survey/index" */))
const _9f48eb0c = () => interopDefault(import('../client/pages/my_account/cancel/survey/confirmation.vue' /* webpackChunkName: "pages/my_account/cancel/survey/confirmation" */))
const _6f06ff13 = () => interopDefault(import('../client/pages/pages/_page.vue' /* webpackChunkName: "pages/pages/_page" */))
const _06dc2aca = () => interopDefault(import('../client/pages/product/_id.vue' /* webpackChunkName: "pages/product/_id" */))
const _5cc03d02 = () => interopDefault(import('../client/pages/index.vue' /* webpackChunkName: "pages/index" */))
const _130e534d = () => interopDefault(import('../client/pages/_landing/checkout.vue' /* webpackChunkName: "pages/_landing/checkout" */))
const _316387ba = () => interopDefault(import('../client/pages/_landing/recommendations.vue' /* webpackChunkName: "pages/_landing/recommendations" */))
const _56153e2a = () => interopDefault(import('../client/pages/_landing/register.vue' /* webpackChunkName: "pages/_landing/register" */))
const _0d219c8a = () => interopDefault(import('../client/pages/_landing/quiz/_questionNumber.vue' /* webpackChunkName: "pages/_landing/quiz/_questionNumber" */))
const _6e841660 = () => interopDefault(import('~/pages/product/_id.vue' /* webpackChunkName: "" */))
const _832cdbe2 = () => interopDefault(import('../client/pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/accessibility",
    component: _407fc104,
    name: "accessibility"
  }, {
    path: "/ask-the-nutritionist",
    component: _d5274abc,
    name: "ask-the-nutritionist"
  }, {
    path: "/checkout",
    component: _5613b56e,
    name: "checkout"
  }, {
    path: "/contact",
    component: _1ef59b50,
    name: "contact"
  }, {
    path: "/forgot-password",
    component: _130416b5,
    name: "forgot-password"
  }, {
    path: "/free_trial",
    component: _66dc0503,
    name: "free_trial"
  }, {
    path: "/get_started",
    component: _75fa2fc8,
    name: "get_started"
  }, {
    path: "/giveaway-terms",
    component: _d084438e,
    name: "giveaway-terms"
  }, {
    path: "/instagram",
    component: _3bf49fe2,
    name: "instagram"
  }, {
    path: "/jobs",
    component: _4229a656,
    name: "jobs"
  }, {
    path: "/login",
    component: _2667e019,
    name: "login"
  }, {
    path: "/loyalty-program",
    component: _063948ad,
    name: "loyalty-program"
  }, {
    path: "/my_account",
    component: _3cf1979d,
    name: "my_account"
  }, {
    path: "/nutritionists",
    component: _2121d571,
    name: "nutritionists"
  }, {
    path: "/our-story",
    component: _3451cb38,
    name: "our-story"
  }, {
    path: "/personalize",
    component: _860ec778,
    name: "personalize"
  }, {
    path: "/plan-and-save",
    component: _45df5f87,
    name: "plan-and-save"
  }, {
    path: "/press",
    component: _56a797f3,
    name: "press"
  }, {
    path: "/privacy",
    component: _7621a6b8,
    name: "privacy"
  }, {
    path: "/product-philosophy",
    component: _5b3c928f,
    name: "product-philosophy"
  }, {
    path: "/products",
    component: _98921f38,
    name: "products",
    children: [{
      path: "category/:category?",
      component: _2171f0c7,
      name: "products-category-category"
    }]
  }, {
    path: "/recommendations",
    component: _09dfaa0a,
    name: "recommendations"
  }, {
    path: "/refer-a-friend",
    component: _968da892,
    name: "refer-a-friend"
  }, {
    path: "/reset-password",
    component: _60db57d9,
    alias: ["/hum_login/reset_password"],
    name: "reset-password"
  }, {
    path: "/science",
    component: _a5b560d8,
    name: "science"
  }, {
    path: "/sitemap",
    component: _e3cc5d36,
    name: "sitemap"
  }, {
    path: "/sustainability",
    component: _5695e5b2,
    name: "sustainability"
  }, {
    path: "/terms-and-conditions",
    component: _33ecec74,
    name: "terms-and-conditions"
  }, {
    path: "/wholesale-inquiries",
    component: _afd48f74,
    name: "wholesale-inquiries"
  }, {
    path: "/checkout/confirmation",
    component: _4030f08e,
    name: "checkout-confirmation"
  }, {
    path: "/my_account/cancel",
    component: _1bcebefc,
    name: "my_account-cancel"
  }, {
    path: "/my_account/customer",
    component: _3b3bad63,
    name: "my_account-customer"
  }, {
    path: "/my_account/membership",
    component: _09779bca,
    name: "my_account-membership"
  }, {
    path: "/my_account/nutrition-report",
    component: _2a19ec0e,
    name: "my_account-nutrition-report"
  }, {
    path: "/my_account/order-history",
    component: _32c951e3,
    name: "my_account-order-history"
  }, {
    path: "/my_account/routine",
    component: _38a405cf,
    name: "my_account-routine"
  }, {
    path: "/my_account/cancel/confirmation",
    component: _6afdd996,
    name: "my_account-cancel-confirmation"
  }, {
    path: "/my_account/cancel/survey",
    component: _51f59cdd,
    name: "my_account-cancel-survey"
  }, {
    path: "/my_account/cancel/survey/confirmation",
    component: _9f48eb0c,
    name: "my_account-cancel-survey-confirmation"
  }, {
    path: "/pages/:page?",
    component: _6f06ff13,
    name: "pages-page"
  }, {
    path: "/product/:id?",
    component: _06dc2aca,
    name: "product-id"
  }, {
    path: "/",
    component: _5cc03d02,
    name: "index"
  }, {
    path: "/:landing/checkout",
    component: _130e534d,
    name: "landing-checkout"
  }, {
    path: "/:landing/recommendations",
    component: _316387ba,
    name: "landing-recommendations"
  }, {
    path: "/:landing/register",
    component: _56153e2a,
    name: "landing-register"
  }, {
    path: "/:landing/quiz/:questionNumber?",
    component: _0d219c8a,
    name: "landing-quiz-questionNumber"
  }, {
    path: "/product/:id/:slug",
    component: _6e841660,
    name: "product"
  }, {
    path: "/*",
    component: _832cdbe2,
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
